import React, {useState} from 'react'
import {useParams} from 'react-router-dom'
import ReviewDrawer from './Drawer/ReviewDrawer'

interface ActionDropdownProps {
  reviewId: string
  systemId?: string
  onEdit?: boolean
  onDelete: (reviewId: string, systemId?: string, isReview?: boolean) => void
  isReview?: boolean
  status?: string
  statusHeader?: string
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({
  reviewId,
  systemId,
  onEdit,
  onDelete,
  isReview,
  status,
  statusHeader
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const {id} = useParams()
  return (
    <>
      <div className='dropdown'>
        <button
          className='btn btn-sm btn-icon border bg-gray-100'
          type='button'
          id={`dropdownMenu-${reviewId}-${systemId || 'review'}`}
          data-bs-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-dots'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
            <path d='M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
            <path d='M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
          </svg>
        </button>
        <ul
          className='dropdown-menu px-2 fs-6 mt-2'
          aria-labelledby={`dropdownMenu-${reviewId}-${systemId || 'review'}`}
          style={{borderRadius: '8px'}}
        >
          {onEdit && (
            <li>
              <button
                className='dropdown-item d-flex align-items-center justify-content-start hover:bg-gray-100 transition-colors duration-150'
                type='button'
                onClick={() => {
                  setIsOpen(true)
                }}
                disabled={statusHeader === 'Completed'}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='18'
                  height='18'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='icon icon-tabler icons-tabler-outline icon-tabler-edit me-2'
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                  <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                  <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                  <path d='M16 5l3 3' />
                </svg>
                Edit Review
              </button>
            </li>
          )}
          {onEdit && <div className='separator my-2'></div>}
          <li>
            <button
              className={`dropdown-item d-flex align-items-center justify-content-start transition-colors duration-150 ${
                status === 'Completed' ? '' : 'hover:bg-gray-100'
              }`}
              style={{
                color: status === 'Completed' ? '#9CA3AF' : '#F15363',
                cursor: status === 'Completed' ? 'not-allowed' : 'pointer',
                opacity: status === 'Completed' ? 0.9 : 1,
                pointerEvents: status === 'Completed' ? 'none' : 'auto',
              }}
              type='button'
              onClick={() => onDelete(reviewId, systemId, isReview)}
              disabled={status === 'Completed'}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke={status === 'Completed' ? '#9CA3AF' : '#F15363'}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-trash me-2'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M4 7l16 0' />
                <path d='M10 11l0 6' />
                <path d='M14 11l0 6' />
                <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
              </svg>
              {isReview ? 'Delete Review' : 'Remove System'}
            </button>
          </li>
        </ul>
      </div>
      <ReviewDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} reviewId={reviewId || id} />
    </>
  )
}

export default ActionDropdown
